import type { PricingVersionTuple } from '../../model/model.ts'

import type { FrRcpaxePricingVersionFormat } from './model.ts'

export const frRcpaxePricingVersions = [
  ['pricing-fr-rcp-axeria-1.0.0-2026-10-04', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<FrRcpaxePricingVersionFormat>[]

export type FrRcpaxePricingVersion = (typeof frRcpaxePricingVersions)[number][0]
